import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";

export default function Add_data_modal({
  select_data,
  open_update_data_modal,
  onUpdateLead,
}) {
  const [ren, setRen] = useState(false);
  const [update_modal_data, setUpdate_modal_data] = useState(select_data);
  const [add_data_modal_Show, set_update_data_modal_Show] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [errors, setErrors] = useState({});
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    if (select_data) {
      setUpdate_modal_data({
        ...select_data,
        business_category: select_data.business_category
          ? select_data.business_category._id
          : "",
      });
    }
  }, [select_data]);

  useEffect(() => {
    set_update_data_modal_Show(open_update_data_modal.modal_open);
  }, [open_update_data_modal]);

  const handleClose = () => {
    set_update_data_modal_Show(false);
  };
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/business-category`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setCategories(response.data.categories);
      } catch (error) {
        console.error("Error fetching categories:", error);
        setCategories([]);
      }
    };
    fetchCategories();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "business_category") {
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        business_category: { ...prevData.business_category, [name]: value },
      }));
    } else {
      setUpdate_modal_data({ ...update_modal_data, [name]: value });
    }
  };

  const handleCategoryChange = (e) => {
    const { value } = e.target;
    setUpdate_modal_data((prevData) => ({
      ...prevData,
      business_category: value,
    }));
  };

  const validateFields = () => {
    const newErrors = {};
    if (!update_modal_data.agent_name)
      newErrors.agent_name = "Agent Name is required";
    if (!update_modal_data.phone_number)
      newErrors.phone_number = "Phone Number is required";
    if (!update_modal_data.customer_name)
      newErrors.customer_name = "Customer Name is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = async () => {
    const token = localStorage.getItem("token");

    if (!validateFields()) {
      Swal.fire("Please fill in all required fields", "", "error");
      return;
    }

    Swal.fire({
      icon: "warning",
      title: "Are you sure you want to take this action?",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const { _id } = update_modal_data;
          if (!_id) {
            throw new Error("ID is not defined");
          }

          // Create a new FormData object
          const formData = new FormData();
          if (update_modal_data.agent_name) {
            formData.append("agent_name", update_modal_data.agent_name);
          }
          formData.append("timestamp", update_modal_data.timestamp);
          formData.append("phone_number", update_modal_data.phone_number);
          formData.append("customer_name", update_modal_data.customer_name);
          formData.append("business_name", update_modal_data.business_name);
          formData.append("address", update_modal_data.address);
          formData.append(
            "business_category",
            update_modal_data.business_category
          );
          formData.append("interested", update_modal_data.interested);
          formData.append("remarks", update_modal_data.remarks);
          formData.append("callremarks", update_modal_data.callremarks);

          formData.append("rating", update_modal_data.rating);
          formData.append("email", update_modal_data.email);

          const res = await axios.put(
            `${process.env.REACT_APP_BASE_URL}/api/v1/leads/${_id}`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );

          if (res.data.success) {
            Swal.fire("Update success", "", "success");
            onUpdateLead(update_modal_data);
            setRen(!ren);
          }
        } catch (error) {
          Swal.fire("Update failed", "", "error");
        }
        set_update_data_modal_Show(false);
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  return (
    <>
      <Modal show={add_data_modal_Show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Leads Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Date *</Form.Label>
              <Form.Control
                type="date"
                name="timestamp"
                value={update_modal_data.timestamp || ""}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label> Agent Name *</Form.Label>
              <Form.Control
                type="text"
                name="agent_name"
                value={update_modal_data.agent_name || ""}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Phone Number *</Form.Label>
              <Form.Control
                type="number"
                name="phone_number"
                value={update_modal_data.phone_number || ""}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Customer Name *</Form.Label>
              <Form.Control
                type="text"
                name="customer_name"
                value={update_modal_data.customer_name || ""}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Business Name</Form.Label>
              <Form.Control
                type="text"
                name="business_name"
                value={update_modal_data.business_name || ""}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Address</Form.Label>
              <Form.Control
                type="text"
                name="address"
                value={update_modal_data.address || ""}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="text"
                name="email"
                value={update_modal_data.email || ""}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Rating *</Form.Label>
              <Form.Control
                as="select"
                name="rating"
                value={update_modal_data.rating || ""}
                onChange={handleChange}
              >
                <option value=""> Select Option</option>
                <option value="0">0-Awful</option>
                <option value="1">1-Bad</option>
                <option value="2">2-NotGood</option>
                <option value="3">3-Good</option>
                <option value="4">4-VeryGood</option>
                <option value="5">5-Excellent</option>
              </Form.Control>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Interested</Form.Label>
              <Form.Control
                as="select"
                name="interested"
                value={update_modal_data.interested || ""}
                onChange={handleChange}
              >
                <option value=""> Select Option</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </Form.Control>
            </Form.Group>
            <Form.Group className="mb-3" controlId="business_category">
              <Form.Label>Business Category *</Form.Label>
              <Form.Control
                as="select"
                name="business_category"
                value={update_modal_data.business_category || ""}
                onChange={handleCategoryChange}
              >
                <option value="">Select Category</option>
                {categories.map((category) => (
                  <option key={category._id} value={category._id}>
                    {category.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Visit Remarks *</Form.Label>
              <Form.Control
                type="text"
                name="remarks"
                value={update_modal_data.remarks || ""}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Call Remarks *</Form.Label>
              <Form.Control
                type="text"
                name="callremarks"
                value={update_modal_data.callremarks || ""}
                onChange={handleChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="primary"
            className="btn btn-sm"
            onClick={handleUpdate}
          >
            Update Lead
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
